import { gql } from '@apollo/client';

export const UPDATE_RESERVATION_MODE = gql`
  mutation UpdateReservationMode($record: UpdateReservationModeInput!) {
    schedule {
      updateReservationMode(record: $record) {
        ok
        error {
          message
          code
        }
        resultId
        result {
          id
          name
          duration
        }
      }
    }
  }
`;
